const points = [
  {
    id: 'about-01',
    icon: 'ri-stack-line',
    title: '按内容形态分区',
    desc: '电影、剧集、动漫、综艺、纪实各自成区，避免把不同更新节奏的内容混在一起，浏览时更容易判断该看什么。',
  },
  {
    id: 'about-02',
    icon: 'ri-refresh-line',
    title: '以更新动态为主线',
    desc: '页面围绕「最近更新了什么」组织信息，先给时间序，再给类型筛选，最后给榜单与专区，形成从新到热再到深入的浏览路径。',
  },
  {
    id: 'about-03',
    icon: 'ri-file-list-3-line',
    title: '每条都带判断信息',
    desc: '条目附带类型、集数进度、地区、评分与一句话说明，帮助你在不点开的情况下先做一轮筛选。',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-100 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-200 bg-background-200">
          <img
            src="https://readdy.ai/api/search-image?query=Cozy%20warm%20home%20theater%20corner%20with%20soft%20amber%20lamp%20light%2C%20stack%20of%20notebooks%20and%20a%20screen%20reflecting%20warm%20tones%2C%20editorial%20photography%2C%20calm%20minimal%20aesthetic%2C%20no%20text&width=1200&height=900&seq=blueberry-about-01&orientation=landscape"
            alt="温暖的客厅观影角落，柔和的灯光与整齐摆放的笔记本"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div>
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-primary-700 bg-primary-100 px-3 py-1 rounded-full">
            <i className="ri-bookmark-3-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            资源整理说明
          </span>
          <h2 className="font-heading mt-3 text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-snug scroll-mt-24">
            蓝莓视频资源是怎么整理的
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            我们把「热门新片」和「全集内容」这两类浏览需求放在同一个页面里解决：想看新上线的，直接看今日更新；想连续追的，进追更专区对齐集数。所有筛选都在本页完成，不跳转、不需要登录。
          </p>

          <ul className="mt-7 space-y-4">
            {points.map((point) => (
              <li key={point.id} className="flex gap-3 md:gap-4">
                <span className="w-10 h-10 shrink-0 rounded-md bg-accent-100 text-accent-900 flex items-center justify-center">
                  <i className={`${point.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="text-sm md:text-base font-bold text-foreground-950">{point.title}</h3>
                  <p className="mt-1 text-xs md:text-sm leading-relaxed text-foreground-700">{point.desc}</p>
                </div>
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="#hot"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-fire-line" aria-hidden="true"></i>
              去热门新片挑一部
            </a>
            <a
              href="#series"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-100 text-secondary-900 text-sm font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-list-2-line" aria-hidden="true"></i>
              看全集与进度
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}